(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds-ultra-options-v98"] && !Shopify.designMode) return;
  try {
    (() => {
  function preserveEditionContext() {
    const current = new URL(window.location.href);
    document.querySelectorAll('.u98-options [data-edition-link]').forEach(link => {
      const target = new URL(link.href, current);
      if (target.origin !== current.origin) return;
      const keys = new Set(current.searchParams.keys());
      keys.forEach(key => {
        if (key === 'view' || key === 'variant') return;
        target.searchParams.delete(key);
        current.searchParams.getAll(key).forEach(value => target.searchParams.append(key, value));
      });
      if (current.hash) target.hash = current.hash;
      link.href = target.href;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preserveEditionContext, { once: true });
  } else {
    preserveEditionContext();
  }
  document.addEventListener('shopify:section:load', preserveEditionContext);
})();
  } catch(e) { console.error(e); }
})();

})();
